const url = process.env.REACT_APP_API_URL;
const auth = process.env.REACT_APP_API_TOKEN;

export const executeCreateUserApi = async (name, cnpj, email, phone) => {
    const fullUsername = 'IMS Free Tier - ' + name;
    const cnpjFormatted = 'IMS Free Tier/' + cnpj;

    try {
        const groupid = await createHostGroup(fullUsername, cnpjFormatted, auth, url);
        const userGroupId = await createUserGroup(fullUsername, groupid, auth, url);
        const userId = await createUser(fullUsername, userGroupId, auth, url, email, phone);
        await createMediaType(userId, fullUsername, groupid, email, phone, auth, url);
        return groupid; // Retornando o groupid para ser usado no React
    } catch (error) {
        console.error('Error:', error);
        alert('Falha em um dos passos do processo. Verifique o console para mais detalhes.');
        throw error; // Garante que o erro será tratado ou exibido apropriadamente
    }
}

async function createHostGroup(fullUsername, cnpjFormatted, auth, url) {
    const hostGroupPayload = {
        "jsonrpc": "2.0",
        "method": "hostgroup.create",
        "params": {
            "name": cnpjFormatted  // Usando CNPJ como o nome do grupo de host
        },
        "auth": auth,
        "id": 1
    };
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(hostGroupPayload)
    });
    const data = await response.json();
    if (data.error) {
        console.error('Error creating user group:', data.error);
        throw new Error('Erro ao criar grupo de usuário: ' + data.error.data);
    }
    return data.result.groupids[0]; // Armazena a resposta da API na variável e retorna para uso posterior
}

async function createUserGroup(fullUsername, groupid, auth, url) {
    const userGroupPayload = {
        "jsonrpc": "2.0",
        "method": "usergroup.create",
        "params": {
            "name": fullUsername,
            "rights": [{"id": groupid, "permission": 2}],
            "users_status": 0
        },
        "auth": auth,
        "id": 2
    };
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(userGroupPayload)
    });
    const data = await response.json();
    if (data.error) {
        console.error('Error creating user group:', data.error);
        throw new Error('Erro ao criar grupo de usuário: ' + data.error.data);
    }
    return data.result.usrgrpids[0]; // Armazena a resposta da API na variável e retorna para uso posterior
}

async function createUser(fullUsername, userGroupId, auth, url, email, phone) {
    const phoneWithPrefix = `55${phone}`;
    const userPayload = {
        "jsonrpc": "2.0",
        "method": "user.create",
        "params": {
            "username": fullUsername,
            "roleid": "1",
            "passwd": "imsnetwork",
            "usrgrps": [
                {
                    "usrgrpid": userGroupId
                }
            ],
            "medias": [
                {
                    "mediatypeid": "19", // Este ID deve ser revisado para garantir que corresponde ao tipo de meio para telefone no seu Zabbix
                    "sendto": phoneWithPrefix, // Enviando com prefixo
                    "active": 0,
                    "severity": 63,
                    "period": "1-7,00:00-24:00"
                },
                {
                    "mediatypeid": "15", // Este ID deve ser revisado para garantir que corresponde ao tipo de meio para e-mail no seu Zabbix
                    "sendto": email, // Enviando como string simples
                    "active": 0,
                    "severity": 63,
                    "period": "1-7,00:00-24:00"
                }
            ]
        },
        "auth": auth,
        "id": 3
    };

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(userPayload)
    });
    const data = await response.json();
    if (data.error) {
        console.error('Error creating user:', data.error);
        throw new Error('Erro ao criar usuário: ' + data.error.data);
    }
    return data.result.userids[0];
}

async function createMediaType(userId, fullUsername, groupid, email, phone, auth, url) {
    const actionPayload = {
        "jsonrpc": "2.0",
        "method": "action.create",
        "params": {
            "name": fullUsername,
            "eventsource": 0,
            "esc_period": "3600",
            "filter": {
                "evaltype": 0,
                "conditions": [
                    {
                        "conditiontype": 0,
                        "operator": 0,
                        "value": groupid
                    },
                    {
                        "conditiontype": 4,  // Condition by trigger severity
                        "operator": 5,  // '>' operator
                        "value": "5"  // Disaster severity
                    }
                ]
            },
            "operations": [
                {
                    "operationtype": 0,
                    "esc_step_from": 1,
                    "esc_step_to": 1,
                    "opmessage_usr": [
                        {
                            "userid": userId
                        }
                    ],
                    "opmessage": {
                        "default_msg": 1,
                        "mediatypeid": "19"
                    }
                }
            ],
            "recovery_operations": [
                {
                    "operationtype": 0,
                    "opmessage_usr": [
                        {
                            "userid": userId
                        }
                    ],
                    "opmessage": {
                        "default_msg": 1,
                        "mediatypeid": "19"
                    }
                }
            ],
            "update_operations": [
                {
                    "operationtype": 0,
                    "opmessage_usr": [
                        {
                            "userid": userId
                        }
                    ],
                    "opmessage": {
                        "default_msg": 1,
                        "mediatypeid": "19"
                    }
                }
            ]
        },
        "auth": auth,
        "id": 3
    };
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(actionPayload)
    });
    const data = await response.json();
    if (!response.ok) throw new Error('Falha na resposta da rede');
    if (data.error) {
        console.error('Error creating action:', data.error);
        throw new Error('Erro ao criar a ação: ' + data.error.data);
    }
}
